// Počet kusů skladem pro zobrazení — stejný práh, jaký používá Shoptet.
//
// Nativní dostupnost Shoptetu (karta výpisu, detail, košík) nad pěti kusy
// přesný počet neukazuje, píše jen „(>5 ks)"; do pěti kusů včetně píše číslo
// („(5 ks)", „(1 ks)"). Vlastní vrstvy nad vyhledávacím indexem (našeptávač,
// výsledky hledání, řada „Nejoblíbenější" na homepage) dostávají z API přesný
// `stock_total` a do 2026-09-15 ho vypisovaly celý („Skladem 45 ks") — vedle
// nativních karet s „>5 ks" to působilo nekonzistentně a prozrazovalo zásobu.
// Každé místo, které z dat kreslí počet kusů, jde přes tuhle funkci.
//
// POZOR: `amount` 0 / null / záporné = u indexu „neznámo", ne „došlo"
// (productCardRender.js hlavička) → `null`, řádek se nekreslí.

export const STOCK_EXACT_MAX = 5; // práh je platformní (Shoptet), ne klientský — do manifestu nepatří

const NBSP = '\u00A0'; // escapem, ne literálem (lint no-irregular-whitespace)

/**
 * @param {number|string|null|undefined} amount počet kusů z indexu
 * @returns {string|null} „3 ks" / „>5 ks" (s NBSP), nebo null bez známého počtu
 */
export function stockAmountText(amount) {
  const n = Number(amount);
  if (!isFinite(n) || n <= 0) return null;
  return (n > STOCK_EXACT_MAX ? '>' + STOCK_EXACT_MAX : String(Math.floor(n))) + NBSP + 'ks';
}
